import { drop, pathOr } from 'core/utils';
import { getLocalStorage, setLocalStorage } from 'core/services/localstorage.service';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { logger } from 'redux-logger';
import { bindStateFactory, isInActionMap } from 'core/utils/state-utils';
import { createBalances } from 'factories';
import { refreshSession } from 'core/services/auth.service';
import thunk from 'redux-thunk';
import {
    loginActionMap,
    entriesActionMap,
    selectedListActionMap,
    reportsActionMap,
    adsActionMap,
    taskListActionMap,
    editEntryActionMap,
    statsActionMap,
    editEntryPaymentsActionMap,
    taskActionMap,
    layoutActionMap
} from 'factories/action-map'

const rootReducer = (state, action) => {
    if(pathOr(null, ['login', 'user'], state)) {
        setLocalStorage('lastUserID', state.login.user.id);
        if(state.selectedList) {
            setLocalStorage('lastSelectedList', state.selectedList.id);
        }
    } 
    //group local storage data by user ID and listID
    if(pathOr(null, ['login', 'user'], state) && state.selectedList) {
        let savedState = getLocalStorage(state.login.user.id);
        let { selectedList, tasks } = state;
        let nextSaved = {
            ...savedState,
            [state.selectedList.id] : {
                ...(savedState ? savedState[state.selectedList.id] : {}),
                selectedList,
                ...(tasks.value.length ? { tasks } : {})
            },
            login : state.login
        }
        setLocalStorage(state.login.user.id, nextSaved);
    } 

    let nextState = state;


    if((isInActionMap(action)(loginActionMap) || isInActionMap(action)(selectedListActionMap)) && state.login.user && nextState.selectedList) {
        let savedState = getLocalStorage(state.login.user.id);
        try {
            nextState = {
               ...nextState,
               ...savedState[nextState.selectedList.id],
               login : savedState.login
            };
        } catch(error) {
            console.error(error);
        }
    }

    //if(isInActionMap(entriesActionMap)) {
    //    let entHistory = state.entriesHistory.length === 10 ? drop(1, state.entriesHistory) : state.entriesHistory;
    //    nextState = {
    //        ...state,
    //        entriesHistory : [
    //            ...entHistory,
    //            state.entries
    //        ]
    //    };
    //}
    let balances = createBalances(nextState.entries) 
    let negBalances = nextState.entries.filter((entry) => {
        let bal = balances[entry.id];
        return bal < 0 && !entry.complete;
    });

    if(isInActionMap(action)(entriesActionMap)) {
        let balHistory = state.balanceHistory.length === 2 ? drop(1, state.balanceHistory) : state.balanceHistory;
        nextState = {
            ...nextState,
            balances,
            balanceHistory : [
                ...balHistory,
                negBalances.length
            ]
        };
    }
    return nextState;
};

const reducers = combineReducers({
    login : bindStateFactory(loginActionMap),
    entries : bindStateFactory(entriesActionMap),
    entriesStats : bindStateFactory(statsActionMap),
    entriesAds : bindStateFactory(adsActionMap),
    tasks : bindStateFactory(taskActionMap),
    taskLists : bindStateFactory(taskListActionMap),
    layout : bindStateFactory(layoutActionMap),
    reports : bindStateFactory(reportsActionMap),
    balanceHistory : (state = [], action) => state,
    balances : (state = {}, action) => state,
    editTask : bindStateFactory(editEntryActionMap),
    editPaymentsTask : bindStateFactory(editEntryPaymentsActionMap),
    selectedList : bindStateFactory(selectedListActionMap),
    currentAction : (state, action) => action
});

export const rootReducers = (state, action) => {
    let intermediateState = reducers(state, action);
    return rootReducer({ ...state, ...intermediateState }, action);
};

export const defaultState = {
    login : null,
    tasks : { value : [] },
    entries : [],
    entriesStats : null,
    entriesAds : [],
    taskLists : [],
    layout : null,
    reports : [],
    balanceHistory : [],
    balances : {},
    editTask : null,
    editPaymentsTask : null,
    currentAction : null
};

export const getStore = async () => {
    let lastUser = getLocalStorage('lastUserID');
    let lastSelectedList = getLocalStorage('lastSelectedList');
    let savedState = getLocalStorage(lastUser);
    let nextState;
    try {
        nextState = {
           ...(savedState && lastSelectedList ? savedState[lastSelectedList] : {}),
           login : (savedState ? savedState.login : null),
           entries : [],
           entriesStats : null,
           entriesAds : [],
           taskLists : [],
           layout : null,
           reports : [],
           balanceHistory : [],
           balances : {},
           editTask : null,
           editPaymentsTask : null,
           currentAction : null
        };
        if(nextState.login) {
            try {
                let updatedLogin = await refreshSession();
                nextState.login = updatedLogin;
                //@ts-ignore
                if(window.ReactNativeWebView && updatedLogin) {
                    //@ts-ignore
                    window.ReactNativeWebView.postMessage(JSON.stringify(updatedLogin));
                }
            } catch(error) {
                nextState.login = null;
                console.error(error);
            }
        }
    } catch(error) {
        console.error(error);
    }
    return createStore(rootReducers, nextState, applyMiddleware(thunk, logger));
};
